import { memo } from "react";

import { DesignMagazinePlanListContainer } from "./container";

type Props = {
	hotelID: string;
};

export const DesignMagazinePlanList = memo(({ hotelID }: Props) => {
	return <DesignMagazinePlanListContainer hotelID={hotelID} />;
});

DesignMagazinePlanList.displayName = "DesignMagazinePlanList";
